<template>
  <div class="home">
    <div class="center-message-spinner">
      <div class="lds-dual-ring"></div>
      <div>
        Wacht voor authenticatie...
      </div>
    </div>
  </div>
</template>

<script>
import { loginService } from "@/services/login";

export default {
  name: "HomeNotLoggedIn",
  created() {
    loginService.resolveUser()
      .then(r => {
        window.sessionStorage.setItem("user", r.data.name);
        this.$emit("loggedInEvent");
      });
  }
};
</script>

<style scoped>
.center-message-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  min-height: 100vh;
}
.home {
  background-color: #3b49a9;
  color: antiquewhite;
  height: 100%;
}
.lds-dual-ring {
  display: inline-block;
  width: 80px;
  height: 80px;
}
.lds-dual-ring:after {
  content: " ";
  display: block;
  width: 64px;
  height: 64px;
  margin: 8px;
  border-radius: 50%;
  border: 6px solid antiquewhite;
  border-color: antiquewhite transparent antiquewhite transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}
@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>